import { createSlice } from "@reduxjs/toolkit";
import _ from "lodash";
import api from "../../AxiosHelper";
import { MIDDLE_CREDENTIAL, storeAssigned, _setTimeOut, getCurrencyCode } from "../../Methods/normalMethods";
import localStorageCall from "../../Methods/localstorage.hook";
import {
    buildPaymentCallbackUrl,
    ensurePaymentCallbackSession,
} from "../../Methods/paymentCallbackSession";

/** Teqtank v3: fallback URL if the shop tab is closed; must be same-origin. Uses callback session (?s=). */
function getPaymentCallbackUrl() {
    if (typeof window === "undefined") return "";
    const customerId = Number(localStorageCall()?.getSingleItem("Token") || 0);
    const sessionId = ensurePaymentCallbackSession(customerId);
    return buildPaymentCallbackUrl(sessionId);
}

const PaymentSlice = createSlice({
    name: "productSlice",
    initialState: {
        paymentOptions: [],
        paymentFormHtml: "",
        paymentError: "",
        iframeLoader: false,
    },
    reducers: {
        setPaymentOptions: (state, actions) => { state['paymentOptions'] = actions?.payload; },
        setFormHtml: (state, actions) => { state['paymentFormHtml'] = actions.payload; },
        setIframeLoader: (state, action) => { state['iframeLoader'] = action?.payload },
        setPaymentError: (state, action) => { state['paymentError'] = action.payload },
    }
});
export const { setPaymentOptions, setFormHtml, setIframeLoader, setPaymentError } = PaymentSlice?.actions;

export const _getPaymentOptions = (callback) => dispatch => {
    dispatch(setPaymentError(''));
    api().setHeaders(MIDDLE_CREDENTIAL).post().data({
        method: "GET",
        // getCurrencyCode(CURRENT_STORE)
        endpoint: `/Money/PaymentOptions/${_.upperCase(storeAssigned())}/${getCurrencyCode(_.upperCase(storeAssigned()))}`
    }).success((res) => {
        if (res?.data?.length > 0) {
            dispatch(setPaymentOptions(res?.data))
            callback(res?.data)
        }
    }).error((err) => {
        dispatch(setPaymentError(err?.errorMessage));
    }).send();
}

export const _getPaymentHtml = (paymentOptionId, data = null) => dispatch => {
    dispatch(setPaymentError(''));
    dispatch(setIframeLoader(true));
    api().setHeaders(MIDDLE_CREDENTIAL).post().data({
        method: "POST",
        endpoint: `/Money/PaymentOptions/Form`,
        data: JSON.stringify({
            paymentOptionId,
            url: typeof window !== "undefined" ? window.location.origin : "",
            callbackUrl: getPaymentCallbackUrl(),
        })
    }).success((res) => {
        if (res?.data) {
            dispatch(setFormHtml(res?.data?.frameSource));
            _setTimeOut(() => dispatch(setIframeLoader(false)), 4000);
        } else {
            dispatch(setIframeLoader(false));
        }
    }).error((err) => {
        dispatch(setIframeLoader(false));
        dispatch(setPaymentError(err?.errorMessage));
    }).send();
}


export default PaymentSlice?.reducer;